import styled from 'styled-components';

export const PageHeader = styled.div`
  background: #242424;
  padding: 0 40px;
  width: 100%;
  min-height: 10.6rem;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  color: #ffdf22;
  cursor: pointer;
`;

export const PageHeaderActionBtnsContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 3rem;
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;
  letter-spacing: 1.25px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const PageHeaderSaveButton = styled.button`
  font-weight: bold;
  font-size: 18px;

  width: 20%;
  height: 45px;

  background: transparent linear-gradient(97deg, #ffdf22 0%, #ffd503 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 50px;

  @media (max-width: 768px) {
    width: 40%;
  }

  @media (max-width: 1280px) {
    width: 30%;
  }

  &:hover {
    opacity: 0.85;
    transition: 0.3s;
  }
`;

export const Container = styled.div`
  padding: 3.6rem 3.1rem;

  form {
    display: flex;
    gap: 8rem;
  }
`;

export const FieldSet = styled.fieldset`
  display: flex;
  flex-direction: column;
  border: none;
  margin-bottom: 28px;

  width: 350px;

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const FormLabel = styled.label`
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
  padding: 0 1.7rem;
  margin-bottom: 0.5rem;
`;

interface RadioOptionProps {
  isSelected: boolean;
}

export const RadioInput = styled.button.attrs({
  type: 'button',
})<RadioOptionProps>`
  display: flex;
  align-items: center;
  background: none;

  padding: 0 1.7rem;
  margin-bottom: 0.6rem;

  .radio {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 2.2rem;
    height: 2.2rem;
    border: 1px solid #fff;
    border-radius: 50%;

    background: transparent;

    margin-right: 0.5rem;

    transition: ${({ theme }) => theme.transition.default};

    .filled {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: inherit;

      background: ${({ isSelected }) => (isSelected ? '#fff' : '#000')};
    }
  }

  > p {
    color: #fff;
    transition: ${({ theme }) => theme.transition.default};
  }

  &:hover {
    .radio {
      border-color: #fff;
    }

    > p {
      color: #fff;
    }
  }
`;

export const SelectContainer = styled.div`
  div {
    border-radius: 2rem;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: fit-content;
  color: #fff;

  padding: 0.5rem;

  border-radius: 50%;

  transition: ${({ theme }) => theme.transition.default};

  background: transparent linear-gradient(155deg, #b50808 0%, #d90606 100%);
  margin-top: 0.8rem;

  :hover {
    transform: scale(1.05);
  }

  :active {
    transform: scale(0.99);
  }
`;

export const DeleteModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    width: 80%;
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      /* background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
      0% 0% no-repeat padding-box; */
      border-radius: 50px;
      opacity: 1;

      &:first-child {
        color: #000;
      }
      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }

      &:first-child {
        background: transparent linear-gradient(97deg, #ffdf22 0%, #ffd503 100%)
          0% 0% no-repeat padding-box;
      }

      &:last-child {
        background: transparent
          linear-gradient(155deg, #b50808 0%, #d90606 100%);
      }
    }
  }
`;
